import { Button, Result } from "antd";
import React, { FC } from "react";

import Link from "next/link";
import { useTranslation } from "next-i18next";

const Ops: FC = () => {
  const { t } = useTranslation("500");

  return (
    <Result
      status="500"
      title="500"
      subTitle={t("subtitle")}
      extra={
        <Link href="/" passHref>
          <Button type="primary">{t("btn-text")}</Button>
        </Link>
      }
    />
  );
};

export default Ops;
